<template>
    <v-app-bar app color="white" flat elevation="0" style="border-bottom: 1px solid #e3e3e3 !important; z-index:2000" :height="heightMenu">
     
      <!-- Icono Navbar -->
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
      <a  href="https://kuroda.com/"><v-img class="ma-8"
        lazy-src="../../modules/rastreo-pedido/assets/logo.png"
        :max-width="widthLogo"
        src="../../modules/rastreo-pedido/assets/logo.png"
      ></v-img></a>
      

      <v-spacer></v-spacer>

      <!-- <v-btn icon>
        <v-icon medium disabled>mdi-account-outline</v-icon>
      </v-btn>

      <v-btn icon>
        <v-icon medium disabled>mdi-cart-outline</v-icon>
      </v-btn> -->

    

    </v-app-bar>
</template>

<script>
export default {
  computed: {
    heightMenu() {
      switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 50
          case 'sm': return 65
          case 'md': return 70
          case 'lg': return 70
          case 'xl': return 75
      }
    },
    widthLogo() {
      switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 90
          case 'sm': return 100
          case 'md': return 110
          case 'lg': return 110
          case 'xl': return 120
      }
    }
  }
}
</script>

<style>

</style>